import React, { useState, useEffect } from "react";
import Header from "../../components/template/website/Header";
import Footer from "../../components/template/estimate/Footer";
import config from "../../config/config";
import { getEstimateDetails } from "../../adapters/payment/payment";
import { VendorRatingSkeleton } from "../../components/skeleton/dashboard/VendorRatingSkeleton";
import { useParams, useHistory } from "react-router";
import { getUserInfoFromSession } from "../../adapters/session/localSessionAdapter";
import momentTimeZone from "moment-timezone";
import { updateEstimateReview } from "../../adapters/dashboard/dashboardAdapater";
import navigationsLinks from "../../constants/navigation_links";
import { Alert } from "reactstrap";
import { ProgressModal } from "../../components/common/ProgressModal";
import { Modal, ModalBody } from "reactstrap";
export function VendorRatings(props) {
  const [isLoading, setIsLoading] = useState(false);
  const [details, setDetails] = useState(null);
  const params = useParams();
  const [error, setError] = useState(null);
  const [success, setSuccess] = useState(false);
  const [progress, setProgress] = useState({
    status: false,
    text: "",
  });
  const [userInfo] = useState(getUserInfoFromSession());
  const formatAddressData = (data) => {
    if (data !== undefined && data !== "" && data !== null) {
      return data;
    }
    return "";
  };

  const getFromAddress = (fromAddressBreakDown) => {
    let fromAddress = [];
    let address = formatAddressData(fromAddressBreakDown["fromAddress"]);
    let locality = formatAddressData(fromAddressBreakDown["fromLocality"]);
    let city = formatAddressData(fromAddressBreakDown["fromCity"]);
    let state = formatAddressData(fromAddressBreakDown["fromState"]);
    let pincode = formatAddressData(fromAddressBreakDown["pincode"]);
    if (address !== "") {
      fromAddress.push(address);
    }
    if (locality !== "") {
      fromAddress.push(locality);
    }
    if (city !== "") {
      fromAddress.push(city);
    }
    if (state !== "") {
      fromAddress.push(state);
    }
    if (pincode !== "") {
      fromAddress.push(pincode);
    }
    return fromAddress.join(", ");
  };
  const getToAddress = (toAddressBreakDown) => {
    let toAddress = [];
    let address = formatAddressData(toAddressBreakDown["toAddress"]);
    let locality = formatAddressData(toAddressBreakDown["toLocality"]);
    let city = formatAddressData(toAddressBreakDown["toCity"]);
    let state = formatAddressData(toAddressBreakDown["toState"]);
    let pincode = formatAddressData(toAddressBreakDown["pincode"]);
    if (address !== "") {
      toAddress.push(address);
    }
    if (locality !== "") {
      toAddress.push(locality);
    }
    if (city !== "") {
      toAddress.push(city);
    }
    if (state !== "") {
      toAddress.push(state);
    }
    if (pincode !== "") {
      toAddress.push(pincode);
    }
    return toAddress.join(", ");
  };

  const [feedBackText, setFeedBackText] = useState("");
  const [ratingScore, setRatingScore] = useState(0);
  const [ratingsList, setRatingsList] = useState([
    { id: "star_1", rating: 1, status: false },
    { id: "star_2", rating: 2, status: false },
    { id: "star_3", rating: 3, status: false },
    { id: "star_4", rating: 4, status: false },
    { id: "star_5", rating: 5, status: false },
  ]);
  const handleRatings = (rating) => {
    const getRatings = [...ratingsList];
    const updatedRatings = getRatings.map((score) => {
      if (score.rating <= rating) {
        score.status = true;
      } else {
        score.status = false;
      }
      return score;
    });
    setRatingScore(rating);
    setRatingsList(updatedRatings);
  };
  const closeProgressModal = () => {
    setProgress({
      status: false,
      text: "",
    });
  };
  const showMoveDate = (date) => {
    const clientTz = momentTimeZone.tz.guess() || "Asia/Culcutta";
    const moveDate = momentTimeZone(date).tz(clientTz);
    return moveDate.format("MMM DD") + ", " + moveDate.format("YYYY");
  };

  const submitFn = async (e) => {
    try {
      setProgress({ status: true, text: "Submitting review..." });
      e.preventDefault();
      const body = {
        estimate_id: params.estimateId,
        vendor_id: params.vendorId,
        rating: ratingScore,
        comment: feedBackText,
      };
      const res = await updateEstimateReview(body);
      if (
        res.data["meta"]["code"] === 200 &&
        res.data["meta"]["status"] === "OK"
      ) {
        closeProgressModal();
        setSuccess(true);
      } else {
        closeProgressModal();
        setError("An Error Occurred, Please try again later.");
      }
    } catch (e) {
      console.error(e);
      closeProgressModal();
      setError("An Error Occurred, Please try again later.");
    }
  };
  useEffect(() => {
    window.scrollTo(0, 0);
    const loadData = async () => {
      setIsLoading(true);
      const body = {
        estimate_id: params.estimateId,
        user_id: userInfo["userId"],
        estimate_status: "estimate_by_id",
        vendor_id: params.vendorId,
      };

      const res = await getEstimateDetails(body);
      if (
        res.data.customer_order_details !== null &&
        res.data.customer_order_details !== undefined
      ) {
        setDetails(res.data.customer_order_details);
        setIsLoading(false);
      } else {
        setIsLoading(false);
      }
    };
    loadData();
  }, [params, userInfo]);
  const JSX = (
    <>
      <Header />
      <main className="container my-5">
        <Alert
          color={"danger"}
          isOpen={error !== null ? true : false}
          toggle={() => {
            setError(null);
          }}
        >
          {error !== null && error}
        </Alert>
        <div className="row">
          <div className="col-sm-12 col-md-12 col-lg-6">
            <div className="text-right rating-banner-img">
              <img
                alt="..."
                className="img-fluid"
                src={`${config.customerPortal}includes/img/customerDashboard/Rating.png`}
              />
            </div>
          </div>
          <div className="col-sm-12 col-md-12 col-lg-5">
            {isLoading === true && <VendorRatingSkeleton />}
            {isLoading === false && details !== null && (
              <>
                <h1>
                  Rate your move with{" "}
                  {details["estimateAmount"]["business_name"]}
                </h1>
                <p>
                  Hi, <strong>{userInfo["customerName"]} </strong> please rate
                  your move with
                  <strong>
                    {" "}
                    {details["estimateAmount"]["business_name"]}
                  </strong>{" "}
                  on
                  <strong>
                    {" "}
                    {showMoveDate(details["moving_on"])}{" "}
                  </strong> from{" "}
                  <strong>{getFromAddress(details["from_address"])}</strong> to
                  <strong> {getToAddress(details["to_address"])}</strong>
                </p>
                <form onSubmit={submitFn}>
                  <div className="stars my-2 d-flex justify-content-between">
                    {ratingsList.map((score) => {
                      return (
                        <label
                          key={score.id}
                          className="star star-1 mr-2"
                          htmlFor="star-1"
                          onClick={() => {
                            handleRatings(score.rating);
                          }}
                        >
                          <img
                            alt="..."
                            src={`${config.customerPortal}includes/img/customerDashboard/star.png`}
                            className={`gray_star ${
                              score.status === false ? "" : "d-none"
                            }`}
                          />
                          <img
                            alt="..."
                            src={`${config.customerPortal}includes/img/customerDashboard/selected_star.png`}
                            className={`yellow_star ${
                              score.status === true ? "" : "d-none"
                            }`}
                          />
                        </label>
                      );
                    })}
                  </div>
                  <div className="form-group">
                    <textarea
                      name="vendor_feedback"
                      id="vendor_feedback"
                      className="form-control"
                      onChange={(e) => {
                        const feedBack = e.target.value;
                        if (feedBack.length > 256) {
                          return;
                        }
                        setFeedBackText(feedBack);
                      }}
                      placeholder="Your Review..."
                      value={feedBackText}
                      style={{ height: "10rem" }}
                    ></textarea>
                    <div className="text-right">
                      <small>characters left:{256 - feedBackText.length}</small>
                    </div>
                  </div>
                  <div className="text-center">
                    <button type="submit" className="btn btn-sm btn-primary">
                      Submit Review
                    </button>
                  </div>
                </form>
              </>
            )}
          </div>
        </div>
      </main>
      <ProgressModal
        isOpen={progress.status}
        text={progress.text}
        toggle={closeProgressModal}
      />
      <SuccessModal isOpen={success} toggle={() => setSuccess(false)} />
      <Footer />
    </>
  );
  return JSX;
}

function SuccessModal(props) {
  const history = useHistory();
  const JSX = (
    <Modal isOpen={props.isOpen} centered={true}>
      <ModalBody>
        <div>
          <div className="d-flex flex-column align-items-center justify-content-center">
            <div className="mx-2 mb-2">
              {" "}
              <h3> Thank you for the review </h3>
            </div>
            <button
              className="btn btn-sm"
              onClick={() => {
                history.push(navigationsLinks.dashboard_page);
              }}
            >
              {" "}
              Dashboard{" "}
            </button>
          </div>
        </div>
      </ModalBody>
    </Modal>
  );
  return JSX;
}
